'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanorama = function ImagePanorama(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z' })
  );
};
ImagePanorama = (0, _pure2.default)(ImagePanorama);
ImagePanorama.displayName = 'ImagePanorama';
ImagePanorama.muiName = 'SvgIcon';

exports.default = ImagePanorama;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/panorama.js
// module id = 2452
// module chunks = 0